




















































































































































































import axios from "axios";
import http from "@/axios/http-common";

import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import { storePenunjang } from "@/store/modules/penunjang";
import { appModule } from "@/store/modules/app";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import ErrorAlert from "@/utility/ErrorAlert";
import moment from "moment";
@Component({
  components: {
    TimeStamp,
    DokterAutoComplete
  }
})
export default class CardPenunjangLain extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() penunjanglain: object;
  @Ref() readonly filesUpload!: HTMLInputElement;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  searchKategori = {};
  files = [];
  currFiles = [];
  // time = new Date()
  //   .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
  //   .toString()
  //   .substr(12, 8);
  time = moment().format("HH:mm:ss");
  maxDate = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  waktu = this.today + " " + this.time;
  // tanggal = this.today;
  // penunjanglain = {
  // };
  waktu_periksa = this.today + " " + this.time;
  kategori = "";
  kbMetode: number | null = null;
  catatan = "";
  loadingSimpan = false;
  sess_login = userModule.user;

  dokter = {};

  get dialog() {
    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }

  // Kategori KB hanya untuk Klinik Kebidanan (08) & Kebidanan Sore (2F);
  // keduanya ber-unit_group "08".
  get isUnitKebidanan() {
    return (
      this.sessLogin.unit_group_id == "08" ||
      ["08", "2F"].includes(this.sessLogin.unit_id)
    );
  }

  get statekategoripenunjanglain() {
    const list = storePenunjang.kategoriPenunjangLain;
    // Kategori "KB" hanya tampil di klinik Kebidanan & Kebidanan Sore
    if (this.isUnitKebidanan) {
      return list;
    }
    return list.filter(
      k => !(typeof k.nama === "string" && k.nama.toUpperCase() === "KB")
    );
  }

  get statekbmetode() {
    return storePenunjang.kbMetode;
  }

  get isKategoriKb() {
    const nama = this.kategori && this.kategori["nama"];
    return typeof nama === "string" && nama.toUpperCase() === "KB";
  }

  @Watch("kategori")
  onKategoriChange() {
    // Bersihkan jenis tindakan KB bila kategori bukan lagi KB
    if (!this.isKategoriKb) {
      this.kbMetode = null;
    }
  }

  mounted() {
    // this.searchKategori = this.statekategoripenunjanglain;
    if (this.sess_login.profesi == "Dokter") {
      this.dokter = {
        id: this.sess_login.id,
        nama: this.sess_login.nama
      };
    } else {
      this.dokter = {};
    }
  }
  get sessLogin() {
    return userModule.user;
  }
  handleFilesUpload() {
    const uploadedFiles = this.filesUpload.files;
    for (let i = 0; i < uploadedFiles.length; i++) {
      this.files.push(uploadedFiles[i]);
    }
  }
  remove(index) {
    // this.currFiles.splice(index, 1);
    this.files.splice(index, 1);
  }
  close() {
    this.dialog = false;
    this.catatan = "";
    this.files = [];
    this.kategori = "";
    this.kbMetode = null;
  }
  setTime(val) {
    // this.time = val;
    this.penunjanglain["waktu_periksa"] = val;
  }
  @Watch("penunjanglain")
  getPenunjanglain() {
    // console.log(this.kronis);
    if (this.penunjanglain["id"] == undefined) {
      this.kategori = "";
      this.kbMetode = null;
      // this.tanggal = this.today;
      this.waktu_periksa = this.today + " " + this.time;
      this.catatan = "";
    } else {
      this.kategori = this.penunjanglain["kategori"].id;
      // this.tanggal = this.penunjanglain["tanggal"];
      this.waktu_periksa = this.penunjanglain["waktu_periksa"];
      this.catatan = this.penunjanglain["catatan"];
    }
  }
  setDokter(val) {
    this.dokter = val;
  }
  simpan() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (this.isKategoriKb && !this.kbMetode) {
        appModule.sendErrorAlert(
          "Silakan pilih jenis tindakan KB terlebih dahulu"
        );
        return;
      }
      const formData = new FormData();
      // if (this.files.length < 1) {
      //   appModule.sendErrorAlert("Belum ada file yang dilampirkan");
      // } else {
      formData.append("penunjang_lain_kategori_id", this.kategori["id"] ?? "");
      if (this.isKategoriKb && this.kbMetode) {
        formData.append("kb_metode_kode", String(this.kbMetode));
      }
      formData.append("register_id", this.register);
      formData.append("waktu_periksa", this.today + " " + this.time);
      formData.append("dokter_id", this.dokter["id"]);
      formData.append("unit_id", this.sessLogin.unit_id);
      formData.append("pasien_rm", this.rm);
      formData.append("catatan", this.catatan);
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        formData.append("file[" + i + "]", file);
      }
      if (this.penunjanglain && this.penunjanglain["id"]) {
        console.log("ubah");
        appModule.NoticeDelay("Berhasil Update Penunjang Lain");
      } else {
        this.loadingSimpan = true;

        http
          .postData(`/penunjang-lain/upload`, formData)
          .then(dt => {
            console.log("res", dt);
            //   const dt = DataPenunjang.saveDataPenunjangLain(
            //     this.penunjanglain["kategori"].id,
            //     this.register,
            //     this.today,
            //     this.time,
            //     this.sessLogin.unit_id,
            //     this.rm,
            //     this.penunjanglain["catatan"],
            //     formData
            //   );
            //   dt.then(dt => {
            appModule.setLoading(false);
            console.log("dt", dt);
            if (dt.data["status"] != 1) {
              appModule.sendErrorAlert(dt["err"]);
            } else {
              storePenunjang.act_penunjang_lain_byReg(this.register);
              console.log("1");

              appModule.NoticeDelay("Berhasil Simpan Penunjang Lain");
              this.close();
            }
          })
          .catch(err => {
            // console.log("err", err);
            ErrorAlert.showErrorAlert(err);
          })
          .finally(() => (this.loadingSimpan = false));
      }
      // }
    }
  }

  addFiles() {
    this.filesUpload.click();
  }
}
